import { Logo } from '@hourly/components/Logo';
import { useAuth } from '@hourly/contexts/AuthContext';
import { Avatar, IconMenu, IconMenuOptionElement } from '@hourly-hds/components';
import { CaretDown, Question, User } from '@hourly-hds/icons/glyph';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import ContactUsDialog from '../ContactUsDialog';
import styles from './Header.module.css';

const Header = ({ name = '' }: { name?: string }) => {
  const navigate = useNavigate();
  const [showContactUsDialog, setShowContactUsDialog] = useState(false);
  const { sessionState } = useAuth();
  const items: IconMenuOptionElement[] = [
    {
      label: 'Log out',
      value: 'logout',
      onAction() {
        navigate('/logout');
      },
    },
  ];

  return (
    <header className={styles.header}>
      <Logo />

      <div className={styles.content}>
        <div className={styles.contactUs} onClick={() => setShowContactUsDialog(true)}>
          <div className={styles.iconWrapper}>
            <Question className={styles.icon} />
          </div>
          <span className={styles.contactUsLabel}>Contact Us</span>
        </div>

        {name && (
          <>
            <Avatar size="small" fallback={<User className={styles.avatar} />} />
            <span className={styles.user}>{name}</span>
            <IconMenu aria-label="account menu" icon={<CaretDown />} options={items} />
          </>
        )}
      </div>
      {showContactUsDialog && (
        <ContactUsDialog
          isOpen={showContactUsDialog}
          partnerId={sessionState?.partnerId || ''}
          onClose={() => setShowContactUsDialog(false)}
        />
      )}
    </header>
  );
};

export default Header;
